// JavaScript Document
    var swiper = new Swiper('.tk_products_top_swiper-container', {
        pagination: {
            el: '.tk_products_top_swiper-pagination',
            type: 'fraction',
        },
        navigation: {
            nextEl: '.tk_products_top_swiper-button-next',
            prevEl: '.tk_products_top_swiper-button-prev',
        },
        loop: true
    });
    var tk_products_detail_galleryTop = new Swiper('.tk_products_detail_gallery-top', {
        spaceBetween: 10,
        effect:'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.tk_products_detail_swiper-button-next',
            prevEl: '.tk_products_detail_swiper-button-prev',
        },
        loop: true,
        loopedSlides: 20
    });
    var tk_products_detail_galleryThumbs = new Swiper('.tk_products_detail_gallery-thumbs', {
        spaceBetween: 8,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
        loop: true,
        direction: 'vertical',
        loopedSlides: 20
    });
    tk_products_detail_galleryTop.controller.control = tk_products_detail_galleryThumbs;
    tk_products_detail_galleryThumbs.controller.control = tk_products_detail_galleryTop;

    var tk_products_color_size_galleryTop = new Swiper('.tk_products_color_size_gallery-top', {
        spaceBetween: 10,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.tk_products_color_size_swiper-button-next',
            prevEl: '.tk_products_color_size_swiper-button-prev',
        },
        loop: true,
        loopedSlides: 20
    });
    var tk_products_color_size_galleryThumbs = new Swiper('.tk_products_color_size_gallery-thumbs', {
        spaceBetween: 8,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
        loop: true,
        direction: 'vertical',
        loopedSlides: 20
    });
    tk_products_color_size_galleryTop.controller.control = tk_products_color_size_galleryThumbs;
    tk_products_color_size_galleryThumbs.controller.control = tk_products_color_size_galleryTop;